export default {
  TITLE: "Tito - Epidemic Cellphone",
  TAB: "Tito and the birds",
  LOGO: "./assets/images/logo-en-us.png",
  SUBTITLE: "The epidemic cellphone",
  DOWNLOAD_TITLE: "Teachers and Professors",
  DOWNLOAD_TEXT: "Download the content and use the game at school",
  DOWNLOAD_BUTTON: "Download",
  PLAY_TEXT: 'Watch the "Tito and the birds" trailer',
  PDF_LINK: "./tito-material-didatico-en-us.pdf",
  TITO_LINK: "http://titoandthebirds.com/",
  SITE_URL: "http://titoandthebirds.com/game/#/en-us",
  SITE_DESCRIPTION:
    "Teachers, children, parents and educators - Learn to Fight Fake News with Tito and the birds",
  COPYRIGHT: `Tito - Epidemic Cellphone by <a href="http://pushstart.com.br/" target="_blank" rel="noopener noreferrer"
  >PushStart</a>. © 2019 Bits Filmes. All rights reserved`,
  PIXEL_CONVERSION_ENUS:
    "https://secure.adnxs.com/px?id=1087807&seg=17258326&t=2"
};



// WEBPACK FOOTER //
// ./src/utils/locales/en-US.js